import { Dialog } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import "./UpgradeDialog.scss";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const UpgradeMessageDialog = (props: any) => {
  const { open, onClose, limit, limitType, fromUpgradePlanDialog } = props;
  const navigate = useNavigate();

  let displayText = "Upgrade your plan to view this feature. ";
  if (limitType && limit) {
    displayText =
      "Your subscription limit is " + limit + " " + limitType + ". ";
  }

  const handleEmailButtonClick = () => {
    window.location.href = "mailto:support@planetwise.io";
  };
  const handleManageSubscriptionClick = () => {
    navigate("/settings/subscription");
    onClose();
  };

  return (
    <Dialog open={open}>
      <div className="pw-upgrade-dialog">
        <div className="flex justify-between items-center w-full">
          <div className={`pw-header-text`}>Please upgrade your plan</div>
          <div className="cursor-pointer">
            <CloseIcon
              className="pw-color-close-attchments"
              onClick={onClose}
            />
          </div>
        </div>
        <div className="mt-8">
          <div className="text-sm">
            <div className="leading-6">
              {!fromUpgradePlanDialog ? <span>{displayText}</span> : ""}
              <span> To upgrade, please </span>
              {!fromUpgradePlanDialog ? (
                <span>
                  <span className="inline-flex">
                    <div
                      className="text-blue-500 cursor-pointer"
                      onClick={handleManageSubscriptionClick}
                    >
                      manage your subscription
                    </div>
                  </span>
                  <span> or </span>
                </span>
              ) : (
                ""
              )}
              <span> get in touch with us at </span>
              <span className="inline-flex">
                <div
                  className="text-blue-500 cursor-pointer"
                  onClick={handleEmailButtonClick}
                >
                  support@planetwise.io
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default UpgradeMessageDialog;
